module.exports = __webpack_public_path__ + "img/12.8160db99.jpg";